export function isTargetWithinEl(event, selector) {
  return event.target.closest(selector);
}
